var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260-727.69q-27.62 0-47.65-20.04-20.04-20.04-20.04-47.65 0-27.62 20.04-47.66 20.03-20.04 47.65-20.04 27.62 0 47.65 20.04 20.04 20.04 20.04 47.66 0 27.61-20.04 47.65-20.03 20.04-47.65 20.04ZM193.85-100v-263.08h-70.77v-235.38q0-26.85 18.88-45.73 18.89-18.89 45.73-18.89h144.62q26.84 0 45.73 18.89 18.88 18.88 18.88 45.73v101.08q-49.92 32.15-83.42 90Q280-349.54 280-280q0 46.23 14.46 86.35 14.46 40.11 36.31 66.57V-100H193.85Zm347.69 1.54q-74.54 0-128.04-53.5Q360-205.46 360-280q0-53.15 29.12-98.12 29.11-44.96 80.11-67.26v43.92q-32.38 20.61-50.81 51.84Q400-318.38 400-280q0 60 40.77 100.77 40.77 40.77 100.77 40.77 53.08 0 94.61-36.16 41.54-36.15 46.16-93.84h40q-6.16 74.54-57.35 122.27-51.19 47.73-123.42 47.73Zm300.84-101.23L748.77-340H540v-280h40v240h191.23l105.08 158.62-33.93 21.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpi);
export default __webpack_public_path__ + "static/media/spi.b72eca47b013425b0bbf9c6dcae73366.svg";
export { ForwardRef as ReactComponent };